const link = "Link-module_link_8hVWJnMA";
const linkStyles = {
  link
};
export {
  linkStyles as default,
  link
};
